<template lang="jade">
  .out_screen_group
    .screen.clearfix(v-el:out-screen)
      .outMask.outResizable(v-for="key in masks"
            v-bind:data-outIndex='key'
            v-bind:id="'outMask'+key"
            v-bind:class="{'outFocus': windowFocus === key}"
            v-on:click='toFocus(key)')
        img.bg(v-bind:src='imgs.outputs[1]')
</template>
<script>
import { photos } from 'src/Service'
import { mapGetters, mapActions } from 'vuex'
import interact from 'interact.js'
// import store from 'src/vuex/videoStore'
// import $ from 'jquery'

export default {
  components: {
  },
  data () {
    return {
      imgs: photos,
      masks: ['1', '2', '3', '4']
    }
  },
  asyncData () {
  },
  computed: {
    // map getters to local variables => http://vuex.vuejs.org/en/getters.html
    // {
    //   data: getters
    // }
    ...mapGetters({
      screenWidth: 'getOutScreenWidth',
      screenHeight: 'getOutScreenHeight',
      windowFocus: 'getWindowFocus'
    })
  },
  methods: {
    // map actions to local methods
    // {
    //   methods: actions
    // }
    ...mapActions({
      toFocus: 'updateWinFocus'
    }),
    interact () {
      let screen = this.$els.outScreen
      let vue = this
      console.log('interact')
      interact('.outFocus')
      .resizable({
        inertia: false,
        preserveAspectRatio: false,
        // restrict two edges
        edges: {
          left: true,
          right: true,
          bottom: true,
          top: true
        },
        restrict: {
          restriction: screen,
          endOnly: false
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        enabled: true,
        invert: 'none',
        onmove: function (event) {
          if (event.type === 'resizemove') {
            vue.resizemoveListener(event)
          }
        },
        onend: function (event) {
          if (event.type === 'resizeend') {
          }
        }
      })
      .draggable({
        // disable inertia throwing
        inertia: false,
        // keep the element within the area of it's parent
        restrict: {
          restriction: screen,
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        autoScroll: false,
        onstart: function (event) {
        },
        onmove: function (event) {
          if (event.type === 'dragmove') {
            vue.dragmoveListener(event)
          }
        },
        onend: function (event) {
        }
      })
    },
    dragmoveListener (event) {
      let target = event.target
      let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    },
    resizemoveListener (event) {
      console.log(this.$store.getters)
      let target = event.target
      let x = (parseFloat(target.getAttribute('data-x')) || 0)
      let y = (parseFloat(target.getAttribute('data-y')) || 0)
      // let width = parseInt(target.style.width.replace('px', ''))
      // let height = parseInt(target.style.height.replace('px', ''))
      let limit = 10 // limit percent of resizing

      // update the element's style
      if (event.rect.width > this.$store.getters.getInScreenWidth / limit) {
        target.style.width = event.rect.width + 'px'
        // width += event.deltaRect.width
        x += event.deltaRect.left
        target.setAttribute('data-x', x)
      }
      if (event.rect.height > this.$store.getters.getInScreenHeight / limit) {
        target.style.height = event.rect.height + 'px'
        y += event.deltaRect.top
        // height += event.deltaRect.height
        target.setAttribute('data-y', y)
      }

      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)'
    },
    renderScreen () {
      // 1. get data
      // 2. computed
      // 3. _operateCSS
      // 4. _interact()
    }
  }, // close methods
  ready () {
    this.interact()
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.screen{
  outline:1px solid #000;
  width:100%;
  height:100vh;
  position: relative;
}
.bg{
  width:100%;
  height:100%;
  position: absolute;
  left: 0;
  right: 0;
}
.outMask{
  overflow:hidden;
  position: absolute;
  left: 0;
  top: 0;
  width:50%;
  height:50%;
  outline:2px solid #f00;
}
.outFocus{
  outline:5px solid #000;
}
</style>



// WEBPACK FOOTER //
// Output-Screen.vue?0d385960